module.exports = __webpack_public_path__ + "static/img/img2.8f29f27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/img2.jpg
// module id = U2N7
// module chunks = 0